module.exports = __webpack_public_path__ + "static/title02-f8e7fc5f5e030edd80525ec5af6fe961.png";